/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Users_LabelInputs */

const en_team_manager_users_label = /** @type {(inputs: Team_Manager_Users_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Users`)
};

const fr_team_manager_users_label = /** @type {(inputs: Team_Manager_Users_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisateurs`)
};

const de_team_manager_users_label = /** @type {(inputs: Team_Manager_Users_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer`)
};

const it_team_manager_users_label = /** @type {(inputs: Team_Manager_Users_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utenti`)
};

const ru_team_manager_users_label = /** @type {(inputs: Team_Manager_Users_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользователи`)
};

const es_team_manager_users_label = /** @type {(inputs: Team_Manager_Users_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuarios`)
};

const zh_cn2_team_manager_users_label = /** @type {(inputs: Team_Manager_Users_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户`)
};

const ja_team_manager_users_label = /** @type {(inputs: Team_Manager_Users_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザー`)
};

const hi_team_manager_users_label = /** @type {(inputs: Team_Manager_Users_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ताओं`)
};

const pt_pt2_team_manager_users_label = /** @type {(inputs: Team_Manager_Users_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuários`)
};

/**
* | output |
* | --- |
* | "Users" |
*
* @param {Team_Manager_Users_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_users_label = /** @type {((inputs?: Team_Manager_Users_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Users_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_users_label(inputs)
	if (locale === "de") return de_team_manager_users_label(inputs)
	if (locale === "it") return it_team_manager_users_label(inputs)
	if (locale === "ru") return ru_team_manager_users_label(inputs)
	if (locale === "es") return es_team_manager_users_label(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_users_label(inputs)
	if (locale === "ja") return ja_team_manager_users_label(inputs)
	if (locale === "hi") return hi_team_manager_users_label(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_users_label(inputs)
	return en_team_manager_users_label(inputs)
});